export default __webpack_public_path__ + "static/media/txt.9a8d5418.svg";